import { createGlobalStyle } from 'styled-components';
import MuliTTF from './fonts/Muli-Regular.ttf';
import MuliBoldTTF from './fonts/Muli-Bold.ttf';
import MuliSemiBoldTTF from './fonts/Muli-SemiBold.ttf';
export const GlobalStyle = createGlobalStyle `
  @font-face {
    font-family: 'Muli';
    font-style: normal;
    src: local('Muli'), local('Muli'),
        url(${MuliTTF}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Muli Bold';
    src: local('Muli Bold'), local('Muli Bold'),
        url(${MuliBoldTTF}) format('truetype');
  }

  @font-face {
    font-family: 'Muli SemiBold';
    src: local('Muli SemiBold'), local('Muli SemiBold'),
        url(${MuliSemiBoldTTF}) format('truetype');
  }
`;
